import * as dat from 'dat.gui';
import ShortcutTriggers from 'app/shortcuts/ShortcutTriggers';
import { getLS } from 'utils/localStoarge';

export class ShortcutStub {
  constructor() {}
  reset() {}
  addPondData() {}
  showLevelSettings() {}
}

const TRIGGER = '↑ ↑ ↓ ↓ ← →';

export default class Shortcuts {
  constructor(game, { model: shortcutsModel, isVisible: isVisible = false }) {
    this.game = game;
    this.model = shortcutsModel;

    this.gameSettings = null;
    this.saveSettings = null;
    this.levelSettings = null;

    this.myCreaturesUnlockedControl = null;
    this.currentPondControl = null;
    this.pondDebugControl = null;
    this.unlockArrowsControl = null;

    this.saveControl = null;

    this.soundControl = null;
    this.sfxControl = null;
    this.musicControl = null;
    this.voControl = null;
    this.captionsControl = null;

    this.boundClearSaves = this.clearSaves.bind(this);

    this.boundToggle = this.toggleDisplay.bind(this);

    this.boundToggleDebugPond = this.toggleDebugPond.bind(this);
    this.boundToggleUnlockArrows = this.toggleUnlockArrows.bind(this);

    this.boundToggleSound = this.toggleSound.bind(this);
    this.boundToggleSFX = this.toggleSFX.bind(this);
    this.boundToggleMusic = this.toggleMusic.bind(this);
    this.boundToggleVO = this.toggleVO.bind(this);
    this.boundToggleCaptions = this.toggleCaptions.bind(this);

    this.isVisible = isVisible;

    this.trigger = new ShortcutTriggers({
      sequence: TRIGGER,
      onComplete: this.boundToggle,
      onFail: (val) => {
        console.log('FAIL', val);
      },
    });
  }

  toggleDisplay() {
    this.isVisible ? this.hide() : this.show();
  }

  toggleDebugPond() {
    this.game.controller.shortcutDebugPond(this.model.pondDebug);
  }

  toggleUnlockArrows() {
    this.game.controller.updateShortcutsState(this.model);
  }

  toggleSound() {
    this.game.sounds.soundVolume = this.model.sound ? 1 : 0;
  }
  toggleSFX() {
    this.game.sounds.sfxVolume = this.model.sfx ? 1 : 0;
  }
  toggleMusic() {
    this.game.sounds.musicVolume = this.model.music ? 1 : 0;
  }
  toggleVO() {
    this.game.sounds.voVolume = this.model.vo ? 1 : 0;
  }
  toggleCaptions() {
    this.game.springRollCaptionsPlugin.setMute(!this.model.captions);
  }

  open() {
    this.gui.open();
  }

  close() {
    this.gui.close();
  }

  show() {
    this.isVisible = true;
    this.gui.show();
  }

  hide() {
    this.isVisible = false;
    this.gui.hide();
  }

  clearSaves() {
    const ls = getLS();
    ls.deleteData();
  }

  setVisible() {
    this.isVisible ? this.show() : this.hide();
  }

  /*
  =========================================================================================================
    GAME
  =========================================================================================================
  */
  createGameSettings() {
    this.gameSettings = this.gui.addFolder('Game Settings');
    this.currentPondControl = this.gameSettings
      .add(this.model, 'currentPond')
      .name('Current Pond Save');
    const el = this.currentPondControl.domElement.getElementsByTagName('input')[0]; // make input read only
    el && (el.readOnly = true);

    this.myCreaturesUnlockedControl = this.gameSettings
      .add(this.model, 'myCreaturesUnlocked')
      .name('My creatures unlocked');

    this.pondDebugControl = this.gameSettings
      .add(this.model, 'pondDebug')
      .name('Debug Pond')
      .onChange(this.boundToggleDebugPond);

    this.unlockArrowsControl = this.gameSettings
      .add(this.model, 'arrowsUnlocked')
      .name('Unlock Arrows')
      .onChange(this.boundToggleUnlockArrows);

    this.gameSettings.open();
  }

  /*
  =========================================================================================================
    SAVE
  =========================================================================================================
  */
  createSaveSettings() {
    this.saveSettings = this.gui.addFolder('Saved Data');
    this.saveControl = this.saveSettings
      .add(this.model, 'clearPlayerSaves')
      .name('Delete all Pond Saves')
      .onChange(this.boundClearSaves);

    // this.saveSettings.open();
  }

  /*
  =========================================================================================================
    AUDIO
  =========================================================================================================
  */
  createAudioSettings() {
    this.audioSettings = this.gui.addFolder('Audio');
    this.soundControl = this.audioSettings
      .add(this.model, 'sound')
      .name('Sound')
      .onChange(this.boundToggleSound);
    this.sfxControl = this.audioSettings
      .add(this.model, 'sfx')
      .name('SFX')
      .onChange(this.boundToggleSFX);
    this.musicControl = this.audioSettings
      .add(this.model, 'music')
      .name('Music')
      .onChange(this.boundToggleMusic);
    this.voControl = this.audioSettings
      .add(this.model, 'vo')
      .name('VO')
      .onChange(this.boundToggleVO);
    this.captionsControl = this.audioSettings
      .add(this.model, 'captions')
      .name('Captions')
      .onChange(this.boundToggleCaptions);
    // this.audioSettings.open();
  }

  /*
  =========================================================================================================
    LEVELS
  =========================================================================================================

  /*
  =========================================================================================================
    API
  =========================================================================================================
  */
  create() {
    dat.GUI.TEXT_CLOSED = 'Close Shortcuts';
    dat.GUI.TEXT_OPEN = 'Open Shortcuts';
    this.gui = new dat.GUI({ name: 'Shortcuts', closed: true, autoPlace: false, width: 300 });
    this.gui.domElement.id = 'gui';
    document.getElementById('shortcuts-container').appendChild(this.gui.domElement);
    this.createGameSettings();
    this.createSaveSettings();
    this.createAudioSettings();
    this.close();
    this.hide();
  }

  update() {
    this.currentPondControl.updateDisplay();
  }

  reset() {
    this.model.currentPond = 'none';
    this.currentPondControl.updateDisplay();
    this.levelSettings && this.gui.removeFolder(this.levelSettings);
    this.levelSettings = null;
  }

  addPondData({ saveId }) {
    this.model.currentPond = saveId;
    this.currentPondControl.updateDisplay();
  }

  showLevelSettings() {
    this.currentPondControl.updateDisplay();
  }

  cleanUp(control) {
    if (control) {
      control.remove();
      control = null;
    }
  }

  destroy() {
    // this.boundQuestSelect = null;
    this.cleanUp(this.unlockArrowsControl);
    this.cleanUp(this.myCreaturesUnlockedControl);
    this.cleanUp(this.currentPondControl);
    this.cleanUp(this.pondDebugControl);
    this.gui.removeFolder(this.gameSettings);
    this.gameSettings = null;

    this.cleanUp(this.saveControl);
    this.gui.removeFolder(this.saveSettings);
    this.saveSettings = null;

    this.cleanUp(this.soundControl);
    this.cleanUp(this.sfxControl);
    this.cleanUp(this.musicControl);
    this.cleanUp(this.voControl);
    this.cleanUp(this.captionsControl);
    this.gui.removeFolder(this.audioSettings);
    this.audioSettings = null;

    this.gui.removeFolder(this.levelSettings);
    this.levelSettings = null;

    this.gui.destroy();
    this.gui = null;

    this.trigger.destroy();
    this.trigger = null;
  }
}
